var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 910 c-18 -20 -18 -22 51 -91 l69 -71 -25 -16 c-51 -34 -128 -114 -151 -156 -21 -40 -21 -46 -9 -77 22 -51 136 -160 202 -192 120 -57 266 -70 402 -36 l48 12 79 -79 79 -78 22 22 23 22 -380 380 c-209 209 -383 380 -386 380 -3 0 -14 -9 -24 -20z m129 -262 c-27 -52 -30 -153 -6 -215 11 -29 16 -53 10 -53 -20 0 -138 128 -138 150 0 12 25 47 63 86 70 71 98 84 71 32z m166 -116 c0 -60 35 -96 91 -90 35 3 43 -1 82 -40 41 -42 41 -44 22 -58 -38 -28 -96 -37 -153 -24 -71 16 -144 84 -162 150 -14 52 -7 117 16 161 l16 31 44 -43 c39 -38 44 -48 44 -87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 802 c0 -21 48 -52 81 -52 100 0 188 -65 215 -157 9 -30 14 -66 11 -79 -4 -25 36 -74 50 -60 5 4 8 40 8 79 0 53 -6 83 -21 114 l-21 43 29 -18 c36 -20 128 -119 128 -136 0 -15 -26 -53 -64 -94 l-30 -32 23 -23 22 -22 43 49 c24 27 51 64 61 83 18 33 18 35 0 71 -54 102 -197 205 -323 231 -62 13 -212 15 -212 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPreview);
export default __webpack_public_path__ + "static/media/noPreview.ae36126187d5442ef45a232217ffcc90.svg";
export { ForwardRef as ReactComponent };